// extracted by mini-css-extract-plugin
module.exports = {"body":"Prices_body__3eheh","table":"Prices_table__3az8L"};